import { dateRangePickerDayClasses } from './DateRangePickerDay/DateRangePickerDay.data'
import { dateRangePickerMonthsClasses } from './DateRangePickerMonths/DateRangePickerMonths.data'
import { dateRangePickerYearsClasses } from './DateRangePickerYears/DateRangePickerYears.data'

export const calendarDimensions = {
  paddingMultiplier: 1,
  dayButtonSize: 40,
  height: 284,
}

export const dateRangePickerClasses = {
  day: dateRangePickerDayClasses,
  yearSelector: dateRangePickerYearsClasses,
  monthSelect: dateRangePickerMonthsClasses,
  fullWidth: 'date-picker--full-width',
}

export const DATE_PICKER_DATE_FORMAT = 'MM/DD/YYYY'
export const DATE_PICKER_MIN_YEAR = 1900
export const DATE_PICKER_MAX_YEAR = 2099
